export default "__VITE_ASSET__CcFCRT8x__"